// extracted by mini-css-extract-plugin
export default {"overlay":"Dv-z","bodyOpen":"Ev-z","content":"Fv-z","header":"Gv-z","close":"Hv-z","closeNoHeading":"Iv-z"};